<ejs-dialog #dialog id='dialog' [buttons]='dlgButtons' isModal='true' [animationSettings]='animationSettings'
    [closeOnEscape]='true' [showCloseIcon]='false' [width]='width' [customers]='customers'
    [subscriptions]='subscriptions' [position]='position' [visible]='companyDialogVisible' [height]='modalHeight'
    (beforeOpen)='beforeOpenDialog($event)'>

    <div class="card">
        <div class="card-header bg-primary">
            <h4 class="card-title text-white">Select a Company<span *ngIf="showDataScopeSelection"> and/or Health
                    Authority</span></h4>
        </div>
        <div class="card-body">
            <div [hidden]="customers?.length === 1" class="message">
                Please choose a Company
            </div>
            <p>
                <ejs-dropdownlist #ddwCustomers id='ddwCustomers' [dataSource]='customers' [fields]='fields'
                    (change)='customerChanged($event)' [placeholder]='customersWaterMark' [popupHeight]='ddwHeight'>
                </ejs-dropdownlist>
            </p>

            <div [hidden]="!showDataScopeSelection" class="message">
                Please choose a Health Authority

                <ejs-dropdownlist #ddwDataScopes id='ddwDataScopes' [dataSource]='subscriptions'
                    [fields]='subscriptionFields' (change)='channelChanged($event)'
                    [placeholder]='subscriptionsWaterMark' [popupHeight]='ddwHeight'>
                </ejs-dropdownlist>
            </div>
        </div>
    </div>
</ejs-dialog>